import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../../shared';
import { ClientePipeSharedModule } from '../../../pipes';
import { ClienteTypeaheadSharedModule } from '../../../typeahead';

import { ClienteCentralCompraParticipanteFormComponent } from './cliente-central-compra-participante-form.component';
import { ClienteCentralCompraParticipanteFormInsertComponent } from './form-insert';
import { ClienteCentralCompraParticipanteFormInsertModalComponent } from './form-insert-modal';

@NgModule({
    imports: [
        SharedModule,
        ClientePipeSharedModule,
        ClienteTypeaheadSharedModule
    ],
    declarations: [
        ClienteCentralCompraParticipanteFormComponent,
        ClienteCentralCompraParticipanteFormInsertComponent,
        ClienteCentralCompraParticipanteFormInsertModalComponent
    ],
    exports: [
        ClienteCentralCompraParticipanteFormComponent,
        ClienteCentralCompraParticipanteFormInsertModalComponent
    ]
})
export class ClienteCentralCompraParticipanteFormModule { }
